import React from 'react';
import { Box, Typography } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { LocationPopover as StyledLocationPopover, LocationButton } from './styles';
import { useTranslation } from 'next-i18next';

interface LocationPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  locationCategories: string[];
  onLocationClick: (category: string) => void;
}

const LocationPopover: React.FC<LocationPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  locationCategories,
  onLocationClick,
}) => {
  const { t } = useTranslation('common');
  
  return (
    <StyledLocationPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
    >
      <Box sx={{ maxHeight: '540px', overflowY: 'auto', paddingBottom: '10px' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1, p: 1 }}>
          {t('search_from')}
        </Typography>
        {locationCategories.map((category) => (
          <LocationButton
            key={category}
            onClick={() => onLocationClick(category)}
            endIcon={<KeyboardArrowRightIcon />}
          >
            {category}
          </LocationButton>
        ))}
      </Box>
    </StyledLocationPopover>
  );
};

export default LocationPopover; 